import script from "./Bt.vue?vue&type=script&setup=true&lang=ts"
export * from "./Bt.vue?vue&type=script&setup=true&lang=ts"

import "./Bt.vue?vue&type=style&index=0&id=81d60966&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81d60966"]])

export default __exports__